// extracted by mini-css-extract-plugin
export default {"benefitsSection":"benefitsCustomers_benefitsSection__NDg0I","benefitsBody":"benefitsCustomers_benefitsBody__grOu8"};